<app-tab-toolbar [tabId]="'energyWater'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges" [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement" [showKeywordsToggle]="true" [keywordsVisible]="showKeywords" (keywordsVisibleChange)="showKeywords = $event" (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      <span>There is no data for the selected year</span>
    </div>
  }
</app-tab-toolbar>

<div class="ew-content" [formGroup]="form" [appReadOnlyTab]="'energyWater'">

  <div class="main-layout">
  <div class="left-column">

    <!-- Energy Section -->
    <div class="ew-section">
      <div class="energy-grid">
        <!-- Title header -->
        <div class="ht-label"></div>
        <div class="ht-title-header" style="grid-column: span 6">Energy</div>

        <!-- Column headers -->
        <div class="ht-label"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header">Restatement</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header">Restatement</div>

        <!-- Energy rows -->
        @for (row of energyRows; track row.key) {
          <div class="ht-label" [class.ht-row-header]="row.bold" [class.ht-indent]="row.indent">{{ row.label }}</div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key))">{{ formatNumber(getOtherValue(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            @if (canShowPct(row)) {
              <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" [formControlName]="row.key + 'Pct'" class="ht-input" placeholder="%">
            }
          </div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key + 'Restatement'" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key + 'Restatement'))">{{ formatNumber(getOtherValue(row.key + 'Restatement')) }}</span>}
          </div>
          <div class="ht-cell">
            <select [formControlName]="row.key + 'UnitId'" class="ht-select" [title]="getUnitName(form.get(row.key + 'UnitId')?.value)">
              <option value=""></option>
              @for (unit of getUnitsForRow(row, energyUnits); track unit.id) {
                <option [value]="unit.id" [title]="unit.name">{{ unit.name }}</option>
              }
            </select>
            @if (otherMeasurement) {<span class="ht-other" [title]="getUnitName(getOtherStringValue(row.key + 'UnitId'))">{{ getUnitName(getOtherStringValue(row.key + 'UnitId')) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConverted(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key))">{{ formatNumber(getOtherConverted(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConvertedRestatement(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key, 'Restatement'))">{{ formatNumber(getOtherConverted(row.key, 'Restatement')) }}</span>}
          </div>
        }
      </div>

      @if (showKeywords) {
        <div class="keywords-section" formGroupName="keywords">
          <div class="section-header"><span>Keywords</span></div>
          <div class="keywords-fields"><app-keyword-input name="energy" label="Energy" /></div>
        </div>
      }
    </div>

  </div>

  <div class="right-column">

    <!-- Water Section -->
    <div class="ew-section">
      <div class="water-grid">
        <!-- Title header -->
        <div class="ht-label"></div>
        <div class="ht-title-header" style="grid-column: span 6">Water</div>

        <!-- Column headers -->
        <div class="ht-label"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header">Restatement</div>
        <div class="ht-col-header"></div>
        <div class="ht-col-header">Current Year</div>
        <div class="ht-col-header">Restatement</div>

        <!-- Water rows -->
        @for (row of waterRows; track row.key) {
          <div class="ht-label" [class.ht-row-header]="row.bold" [class.ht-indent]="row.indent">{{ row.label }}</div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key))">{{ formatNumber(getOtherValue(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            @if (canShowPct(row)) {
              <input type="text" inputmode="decimal" appNumberFormat [min]="0" [max]="100" [decimals]="2" [formControlName]="row.key + 'Pct'" class="ht-input" placeholder="%">
            }
          </div>
          <div class="ht-cell">
            <input type="text" inputmode="numeric" appNumberFormat [formControlName]="row.key + 'Restatement'" class="ht-input">
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherValue(row.key + 'Restatement'))">{{ formatNumber(getOtherValue(row.key + 'Restatement')) }}</span>}
          </div>
          <div class="ht-cell">
            <select [formControlName]="row.key + 'UnitId'" class="ht-select" [title]="getUnitName(form.get(row.key + 'UnitId')?.value)">
              <option value=""></option>
              @for (unit of getUnitsForRow(row, waterUnits); track unit.id) {
                <option [value]="unit.id" [title]="unit.name">{{ unit.name }}</option>
              }
            </select>
            @if (otherMeasurement) {<span class="ht-other" [title]="getUnitName(getOtherStringValue(row.key + 'UnitId'))">{{ getUnitName(getOtherStringValue(row.key + 'UnitId')) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConverted(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key))">{{ formatNumber(getOtherConverted(row.key)) }}</span>}
          </div>
          <div class="ht-cell">
            <input type="text" class="ht-input ht-input-calculated" [value]="formatNumber(getConvertedRestatement(row.key))" readonly>
            @if (otherMeasurement) {<span class="ht-other" [title]="formatNumber(getOtherConverted(row.key, 'Restatement'))">{{ formatNumber(getOtherConverted(row.key, 'Restatement')) }}</span>}
          </div>
        }
      </div>

      @if (showKeywords) {
        <div class="keywords-section" formGroupName="keywords">
          <div class="section-header"><span>Keywords</span></div>
          <div class="keywords-fields"><app-keyword-input name="water" label="Water" /></div>
        </div>
      }
    </div>

  </div>
  </div>

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="5"></textarea>
      </mat-form-field>
      @if (otherMeasurement && otherData?.comments) {
        <div class="comparison-hint">{{ otherData!.comments }}</div>
      }
    </div>
  </section>

</div>
